/**
 * DataDog RUM integration for reporting.
 * When DataDog is not configured, addAction/addError are no-ops so callers do not need to check.
 */
import { useCallback } from 'react';

function noOp(): void {
  // no-op when DataDog is not used
}

export function useDataDog() {
  const addAction = useCallback(<T extends Record<string, unknown>>(_event: string, _context: T) => {
    noOp();
  }, []);

  const addError = useCallback(<T extends Record<string, unknown>>(_error: unknown, _context?: T) => {
    noOp();
  }, []);

  return { addAction, addError };
}

export default useDataDog;
